<template>
  <div class="md-layout md-size-100 md-small-size-100">
      <StatCardWithIcon
        v-for="card in this.servicesTabStats"
        @emit="emit"
        :appIds="card.id_array"
        :title="card.title"
        :value="card.value"
        :icon="card.icon"
        :color="card.color"
        :key="card.title"
        :filter="card.filter"
        :footer="card.footer"
        ableToViewApp
      />
    </div>
</template>

<script>
import StatCardWithIcon from "./ReportingDashboard/components/StatCardWithIcon";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";

export default {
  components: {
    StatCardWithIcon,
    LoadingIconTextButton
  },
  props: ['servicesTabStats', 'filters'],
  data() {
    return {
    }
  },
  methods: {
    emit(data) {
      this.$emit('show',data);
    }
  },
  created() {
  }
}
</script>
<style>
</style>